// src/styles/global.jsx
// Estilos globais NÃO relacionados a tema (cores/light-dark ficam em theme.js).
// Mantemos aqui apenas regras estruturais agnósticas ao modo de cor.
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    /* Evita que o texto dos botões seja cortado/quebrado em larguras pequenas */
    button {
        white-space: nowrap;
    }
`;
